import IParser from "@/types/IParser"
import { IhdStatus, IIhdDetails } from "./ihdDetails.types"
import { IhdDetails } from "./ihdDetails"
import ParseError from "@/types/ParseError"

export interface IIhdDetailsRaw {
  deviceId: string
  deviceType: string
  deviceTypeName: string
  dateInstalled: string
  installedBy: string
  deviceStatus: IhdStatus | null | ""
  dateCommissioned: string
  responsiveStatus: string
  manufacturerCode: string
  manufacturerFullName: string
  manufacturerName: string
  model: string
  modelName: string
  smetsVersion: string
  firmwareVersion: string
  firmwareStatus: string
  mpan: string
  mprn: string
  elecSsd: string
  gasSsd: string
  dateLastUpdated: string
}

export const ihdDetailsParser: IParser<IIhdDetails, IIhdDetailsRaw> = {
  toDomain: (data: IIhdDetailsRaw) => {
    try {
      return new IhdDetails(
        data.deviceId,
        data.deviceType,
        data.deviceTypeName,
        data.installedBy,
        data.deviceStatus,
        data.responsiveStatus,
        data.manufacturerCode,
        data.manufacturerFullName,
        data.manufacturerName,
        data.model,
        data.modelName,
        data.smetsVersion,
        data.firmwareVersion,
        data.firmwareStatus,
        data.mpan,
        data.mprn,
        data.dateInstalled,
        data.dateCommissioned,
        data.elecSsd,
        data.gasSsd,
        data.dateLastUpdated,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
